var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearOverrides({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 15,
      height: 18
    },
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 10.6V7.4H9V2.6C9 2.17565 8.83143 1.76869 8.53137 1.46863C8.23131 1.16857 7.82435 1 7.4 1C6.97565 1 6.56869 1.16857 6.26863 1.46863C5.96857 1.76869 5.8 2.17565 5.8 2.6V7.4H1V10.6M13.8 10.6H1M13.8 10.6V17H1V10.6M10.6 17V12.492M4.2 17V12.492M7.4 17V12.492",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearOverrides);
export default __webpack_public_path__ + "static/media/clear_overrides.1ae20ee4f6130f4abc8db125628fb30e.svg";
export { ForwardRef as ReactComponent };